import {MuWidget} from "mu-widget/lib/MuWidget";
import {ColumnInfo, UiTable, UiTableCell} from "../components/UiTable";
import {formatDate} from "../Utils";
import {UiDms} from "./UiDms";
import {BaseModule} from "./BaseModule";
import {BaseEditor, formGroup} from "../BaseEditor";
import {BaseFilter} from "./BaseFilter";
import {UiDocumentListPreview} from "./UiDocumentListPreview";
import {BuSubject, BuSubjectAddress, ContractFilter, EContractFilter} from "./Types";

export class UiBuSubjects extends BaseModule
{
	public contractFilter: EContractFilter = "";

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`
			<h2 mu-id="label">Seznam subjektů</h2>
			<div class="toolbar">
				<span class="btn btn-link icon-before-add" mu-id="rCreateItem">Přidat subjekt</span>
				<span class="btn btn-link icon-before-reload" mu-id="bReload">Obnovit</span>
				<span class="btn btn-link icon-before-filter" mu-id="bFilter">Celý filtr <span mu-id="filterCount" class="badge"></span></span>
				<span class="btn btn-link icon-before-erase" mu-id="bFilterErase">Zrušit filtr</span>
				<span class="btn btn-link icon-before-document-sheet" mu-id="bExport">Export</span>
				<input type="search" class="form-control flex-grow-1" mu-id="cFulltext" mu-keybind="Enter:bFulltextSearch" />
				<span class="btn btn-link icon-before-search" mu-id="bFulltextSearch">Vyhledat</span>
			</div>
			<table mu-id="list" mu-widget="UiTable" class="table table-hover table-sticky-header">
				<tr mu-id="templates">
					<td mu-template="actions" mu-widget="UiBuSubjectsActionCell">
						<span mu-id="bEdit" class="a icon-before-edit">Upravit</span>
						<span mu-id="bDocuments" class="a icon-before-document-dir">Dokumenty</span>
					</td>
				</tr>
			</table>
			
			<div mu-id="pager" mu-widget="Pager"></div>
		`);
	}

	afterIndex() {
		super.afterIndex();
		this.muNamedWidget.list.columns = [
			new ColumnInfo({field: "id", name: "ID", filterable: false}),
			new ColumnInfo({field: "name", name: "Název"}),
			new ColumnInfo({field: "internalCode", name: "Kód"}),
			new ColumnInfo({field: "ic", name: "IČ"}),
			new ColumnInfo({field: "dic", name: "DIČ"}),
			new ColumnInfo({field: "id", name: "-", template: "ancestor:actions", orderable: false, filterable: false, interactiveOnly: true}),
		];
		if (this.contractFilter) {
			this.muVisible(false, 'rCreateItem');
		}
		this.ui.label.innerText = ContractFilter[this.contractFilter];
	}

	protected openEditor(id: number|null): BaseEditor {
		// @ts-ignore
		return UiDms.instance.openBuSubjectEditor(id);
	}

	/* protected async loadList() {
		this.muParent?.router.pushUpdate(null, {
			[this.muIndexOpts?.id + '_list']: JSON.stringify({
				filter: this.filter,
				orderBy: this.orderBy
			})
		});
		const filterFields = UiBuSubjectsFilter.filtredFields(this.filter);
		for(const ci of this.muNamedWidget.list.columns) {
			ci.isFiltered = filterFields.includes(ci.field);
			ci.isOrdered = this.orderBy.field === ci.field ? this.orderBy.dir : null;
		}
		this.muNamedWidget.list.data = await this.getListData();
		this.muNamedWidget.list.render();
	} */

	protected getListData(forExport: boolean): Promise<any>
	{
		return UiDms.instance.cl.allBuSubjects(
			{ ...this.filter, contractFilter: this.contractFilter, fulltext: this.ui.cFulltext.value },
			this.orderBy,
			forExport ? 0 : this.muNamedWidget.pager.currentItemFrom,
			forExport ? null : this.muNamedWidget.pager.itemPerPage,
		);
	}

	protected openFilter(field: string|null): UiBuSubjectsFilter {
		const filter = this.muParent.openInModal<UiBuSubjectsFilter>(
			'UiBuSubjectsFilter',
			'Nastavit filtr',
			{ muParent: this }
		);
		// filter?.showByField(field);

		return filter;
	}

}

export class UiBuSubjectsActionCell extends UiTableCell {
	// @ts-ignore
	private id: number;

	// @ts-ignore
	private row: BuSubject;

	render(id: number, row: BuSubject) {
		this.id = id;
		this.row = row;
	}

	bEdit_click() {
		const module = this.muParent.muParent.muParent as UiBuSubjects;
		module.loadItem(this.id);
	}

	bDocuments_click() {
		UiDms.instance.openDocumentsPreview("BuSubject", this.id, this.row);
	}
}

export class UiBuSubjectsFilter extends BaseFilter // MuWidget<UiBuSubjects>
{
	beforeIndex() {
		this.muAppendContent(`
			<div mu-id="searchFields">`
			+ formGroup('name', 'Název',
				`<input type="search" class="form-control" mu-bind="name" />`,
				true
			)
			+ formGroup('internalCode', 'Interní kód',
				`<input type="search" class="form-control" mu-bind="internalCode" />`,
				true
			)
			+ formGroup('ic', 'IČ',
				`<input type="search" class="form-control" mu-bind="ic" />`,
				true
			)
			+ formGroup('dic', 'DIČ',
				`<input type="search" class="form-control" mu-bind="dic" />`,
				true
			)
			+ `			
			</div>
			<div class="buttons">
				<span class="btn btn-primary" mu-id="bFilter">Filtrovat</span>
				<span class="btn btn-warning" mu-id="bClearFilter">Zrušit filtr</span>
			</div>
		`);
	}


	public static filtredFields(filterData: any): string[] {
		return Object.keys(filterData).filter(f => {
			const v = filterData[f];
			if (Array.isArray(v)) {
				return v.length > 0;
			} else if ('rangeFrom' in filterData) {
				return filterData.rangeFrom || filterData.rangeTo
			} else return !!v;
		});
	}
}




